import React from "react"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import Accordion from "react-bootstrap/Accordion";
import AvatarSkeleton from "../../../components/skeletons/AvatarSkeleton";
import OvalSkeleton from "../../../components/skeletons/OvalSkeleton";
import {MdKeyboardArrowDown} from "react-icons/md";


export default function PillarViewSkeleton() {
    return(
        <div className={'pillars'}>
            <h3><HeadingSkeleton block={false} height={20} maxWidth={180} /></h3>
            {
                [1,2,3,4].map((item,index)=>{
                    return(
                        <div className={'pillar-card'} key={index}>
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <div className={`pillar-header`}>
                                            <div>
                                                <h4><AvatarSkeleton avatarShape={'circle'} size='large' height={45} width={45}/> <HeadingSkeleton block={true} height={20} maxWidth={100} /></h4>
                                            </div>
                                            <div className={'options'}>
                                                            <span className={`counter`}>
                                                                <OvalSkeleton maxWidth={40} height={10} borderRadius={20}/>
                                                             </span>
                                                <div className={'icon'}>
                                                    <MdKeyboardArrowDown />
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className={'checkkbox-div'}>
                                            {
                                                [1,2].map((item,index)=>{
                                                    return(
                                                        <div className={`checkbox-box`} key={index}>
                                                            <span className={''}><HeadingSkeleton block={false} height={10} maxWidth={100} /></span>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>

                        </div>                                )
                })
            }

        </div>
    )
}